module.exports = __webpack_public_path__ + "static/getStarted_refresher-d85421dafe1747e98b9b31a8924f7d2d.svg";